<div class="drawer-content-screen">
  @if (cannotLoadProviders) {
    <div class="h-full">
      <app-something-went-wrong
        description="Cannot load providers"
        (retryEmitter)="loadProviders()"
        [showPicture]="false"></app-something-went-wrong>
    </div>
  }

  @if (providersIsLoading) {
    <div class="h-full">
      <app-skeleton-form-drawer></app-skeleton-form-drawer>
    </div>
  }

  @if (!cannotLoadProviders && !providersIsLoading) {
    <div class="drawer-content-screen__title">
      {{ 'changeMailAccountPassword' | translate }}
    </div>
    <div class="drawer-content-screen__body">
      <form
        [formGroup]="form"
        autocomplete="off"
        novalidate
        (ngSubmit)="onSubmit()">
        <mat-form-field>
          <mat-label>{{ 'name' | translate }}</mat-label>
          <input matInput id="name" formControlName="name" readonly required />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'providerLabel' | translate }}</mat-label>
          <mat-select id="providerId" formControlName="providerId" required>
            @for (provider of providers; track provider.providerId) {
              <mat-option [value]="provider.providerId">
                {{ provider.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'email' | translate }}</mat-label>
          <input
            matInput
            id="email"
            formControlName="email"
            readonly
            required />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'userName' | translate }}</mat-label>
          <input matInput id="username" formControlName="username" required />
          @if (hasError('username', 'required')) {
            <mat-error>{{ 'aliasIsRequired' | translate }}</mat-error>
          }
          @if (hasError('username', 'maxlength')) {
            <mat-error>{{ 'moreThan256Char' | translate }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'newPassword' | translate }}</mat-label>
          <input
            type="password"
            matInput
            id="newPassword"
            formControlName="newPassword"
            required />
          @if (hasError('newPassword', 'required')) {
            <mat-error>{{ 'newPasswordIsRequired' | translate }}</mat-error>
          }
          @if (hasError('newPassword', 'maxlength')) {
            <mat-error>{{ 'moreThan256Char' | translate }}</mat-error>
          }
        </mat-form-field>
      </form>
    </div>
    <div class="flex w-full justify-end">
      <button
        mat-flat-button
        color="primary"
        [disabled]="isLoading || !form.valid"
        (click)="onSubmit()">
        <app-loading-button
          text="{{ 'save' | translate }}"
          [loading]="isLoading"></app-loading-button>
      </button>
    </div>
  }
</div>
